import { computed } from 'vue';

import { useAuthStore } from '@/store/authStore';

import type { ComputedRef } from 'vue';

export function useAgentCityOffset (): ComputedRef<number> {
  const authStore = useAuthStore();

  return computed(() => authStore.user?.city_of_sale?.timezoneOffset ?? 0);
}
